/*
 * @Description: 
 * @Author: zhanglu
 * @Date: 2021-02-25 09:54:02
 * @LastEditors: zhanglu
 * @LastEditTime: 2021-10-13 17:18:12
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";

const {
  host = "",
  E6_MS_TMS_EXTRA_API_WEB,
  E6_MS_TMS_PERSONALIZE_WEB
} = e6ModuleBaseDataApi;

// 智能识别接口
export function autoRecognition(data) {
  return http({
    url: `${host}${E6_MS_TMS_EXTRA_API_WEB}/aliyun/imageRecognition`,
    method: "post",
    data
  });
}

// 智能识别接口权限
export function checkAutoRecognitionAuth() {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/personalSet/getOcrFunctionSet`,
    method: "get"
  });
}
